import { LoadState } from '@nx-ng/types';
import { getLoadingDetails } from '@nx-ng/util/get-loading-details';
import { ICustomerStateCustomer } from '../types';

export const getCustomerLoadingDetails = (
  customer: ICustomerStateCustomer | undefined
) => {
  let loadState = LoadState.NOT_LOADED;
  let text = '';
  let isUpdating = false;

  if (customer?.updated === LoadState.LOADING) {
    loadState = customer?.updated;
    text = 'updating_customer_details';
    isUpdating = true;
  } else if (customer?.loaded === LoadState.LOADING) {
    loadState = customer?.loaded;
    text = 'loading_customer_details';
  }

  return getLoadingDetails(loadState, text, isUpdating);
};
